"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { setInternalLinkNavigator } from "@/utils/link";

// Registers the app router so the editor's link-click plugin can navigate
// internal links in-app. Mount once, high in the tree.
export default function LinkNavigationBridge() {
  const router = useRouter();

  useEffect(() => {
    setInternalLinkNavigator((href) => {
      try {
        const url = new URL(href, window.location.origin);
        router.push(url.pathname + url.search + url.hash);
      } catch {
        router.push(href);
      }
    });
    return () => setInternalLinkNavigator(null);
  }, [router]);

  return null;
}
